import Icon from 'presentations/views/components/atoms/Icon';
import { primary } from 'presentations/views/styles/color';
import {
  fontSize,
  fontWeight,
  isMediaMax,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import styled from '@emotion/styled';

export interface Props {
  title: string;
  icon?: string;
  className?: string;
}

export default function Component(props: Props) {
  const isMobile = isMediaMax('tablet');
  return (
    <TitleContainer className={props.className}>
      {props.icon && (
        <IconContainer>
          <TitleIcon name={props.icon} size={fontSize(isMobile ? 20 : 28)} />
        </IconContainer>
      )}
      <Title>{props.title}</Title>
    </TitleContainer>
  );
}

const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
`;
const Title = styled.div`
  font-weight: ${fontWeight('bold')};
  font-size: ${fontSize(24)};
  ${mediaMax.tablet} {
    text-align: left;
    font-size: ${fontSize(18)};
  }
`;
const TitleIcon = styled(Icon)`
  color: ${primary};
`;

const IconContainer = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 3px;
  margin-right: ${spacing(8)};
  ${mediaMax.tablet} {
    width: 20px;
    height: 20px;
  }
`;
